import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role")?.toLowerCase();

    // If not logged in → allow public page
    if (!token) return children;

    // Allow logged-in 'user' (Buyer) to reach Seller Login/Onboarding
    const currentPath = window.location.pathname;
    const isSellerPath = currentPath === "/seller-check" || currentPath === "/sellerlogin" || currentPath === "/sellersignup";

    if (role === "user" && isSellerPath) return children;

    // Redirect by role if already logged in
    if (role === "admin" || role === "superadmin") return <Navigate to="/admin/dashboard" replace />;
    if (role === "seller") return <Navigate to="/seller/dashboard" replace />;
    if (role === "user") return <Navigate to="/" replace />;

    return children;
};

export default PublicRoute;
